<template>
  <div id="theme--tuktuk__checkout" :style="{ paddingBottom: data.embed ? '0' : getNavigationBottomHeight() + 'px', }">
    <div v-if="data.themeType != 'TuktukStep1'" class="theme--tuktuk__navbar theme--tuktuk__checkout__navbar">
      <button>
        <img @click="() => {
    setStep(1);
  }
    " alt="" class="img2" :src="require('@/assets/icons/TuktukTheme/ic-tuktuk-arrow-left.svg')
    " />
      </button>

      <h2>{{ $t("tuktukTheme.recipientData") }}</h2>
    </div>
    <!-- Requested fields information-->
    <template v-if="data.themeType == 'TuktukStep1'">


      <div v-if="(data.showOrderReview && showOrderSummery) || data.showBumpProduct"
        class="theme--tuktuk__checkout__info theme--tuktuk__card">
        <div class="theme--tuktuk__container">
          <!--Order Summery-->
          <OrderSummery v-if="data.showOrderReview && showOrderSummery" :data="{ ...data }"
            @updateCartQuantity="updateCartQuantity" @updateCartSummary="updateCartSummary" @changeVariant="changeVariant" @addToCart="addToCart" @addCartItem="addCartItem"  />

          <!--Bump Order-->
          <BumpOrder :data="{ ...data }" v-if="data.showBumpProduct && data.isBump" />
        </div>
      </div>
      <no-ssr>
        <RequestedFields
          @reset-invalid-phone="$emit('reset-invalid-phone')"
          :isInvalidCustomerPhone ="isInvalidCustomerPhone"
          :data="{ ...data }" @updateCartQuantity="updateCartQuantity"
          @saveDataForNexttime="saveDataForNexttime"
          :is-mobile="isMobile"
          @setSelectedAddresses="setSelectedAddresses" 
        />
      </no-ssr>
    </template>
    <template v-else>
      <no-ssr>
         <RequestedFields
            @reset-invalid-phone="$emit('reset-invalid-phone')"
            :isInvalidCustomerPhone="isInvalidCustomerPhone"
            :data="{ ...data }"
            @updateCartQuantity="updateCartQuantity"
            @saveDataForNexttime="saveDataForNexttime"
            :is-mobile="isMobile"
            @setSelectedAddresses="setSelectedAddresses" 
            />
      </no-ssr>

      <div v-if="(data.showOrderReview && showOrderSummery) || data.showBumpProduct"
        class="theme--tuktuk__checkout__info theme--tuktuk__card">
        <div class="theme--tuktuk__container">
          <!--Order Summery-->
          <OrderSummery v-if="data.showOrderReview && showOrderSummery" :data="{ ...data }"
            @updateCartQuantity="updateCartQuantity" @updateCartSummary="updateCartSummary"  @changeVariant="changeVariant" @addToCart="addToCart" @addCartItem="addCartItem"  />

          <!--Bump Order-->
          <BumpOrder :data="{ ...data }" v-if="data.showBumpProduct && data.isBump" />
        </div>
      </div>
    </template>

    <template v-if="data.themeType == 'TuktukStep1'">
      <!--Shipping-->
      <Shipping :user="user" :data="{ ...data }" :shippingCourierItems="shippingCourierItems" />
      <no-ssr>
        <!--Payment Method-->
        <PaymentMethod :data="{ ...data }" :isAddressUnsupported="isAddressUnsupported" v-if="data.showPayment" />
      </no-ssr>
      <!-- Shop Discount -->
      <!-- <ShopDiscount :data="{ ...data }" v-if="data.payload.discount.code || data.payload.automaticDiscount.code" @applyDiscount="applyDiscount" @clearDiscountCode="clearDiscount" @updateDiscountLists="updateDiscountLists"  /> -->


      <no-ssr>
      <!--Order Summery-->
        <ViewOrderSummery v-if="data.orderSummary" :data="{ ...data }" @updateCartTotal="updateCartTotal" @calcCart="calcCart"  @changeVariant="changeVariant" @addToCart="addToCart" @addCartItem="addCartItem"   />
      </no-ssr>

    </template>
    <template v-else>
      <no-ssr>
        <!-- Shop Discount -->
   <!-- <ShopDiscount :data="{ ...data }" v-if="data.payload.discount.code || data.payload.automaticDiscount.code" @applyDiscount="applyDiscount" @clearDiscountCode="clearDiscount" @updateDiscountLists="updateDiscountLists"   /> -->

        <!--Shipping-->
        <Shipping :user="user" :data="{ ...data }" :shippingCourierItems="shippingCourierItems" />

        <Coupon :data="{ ...data }" v-if="data.showCoupon" @updateDiscountLists="updateDiscountLists"  @applyDiscount="applyDiscount" @clearDiscount="clearDiscount"  />

        <!--Order Summery-->
        <ViewOrderSummery v-if="data.orderSummary" :data="{ ...data }" @updateCartTotal="updateCartTotal" @calcCart="calcCart"  @changeVariant="changeVariant" @addToCart="addToCart" @addCartItem="addCartItem"  />
        <!--Payment Method-->
        <PaymentMethod :data="{ ...data }" :isAddressUnsupported="isAddressUnsupported" v-if="data.showPayment" />
      </no-ssr>
    </template>
    <div v-if="data.showOtherContent" class="theme--tuktuk__checkout__user-terms theme--tuktuk__card">
      <div class="theme--tuktuk__container">
        <h2 class="theme--tuktuk__title">{{ data.otherContentTitle || 'Kebijakan Privasi' }}</h2>
        <div v-html="data.otherContent">
        </div>
      </div>
    </div>
    <no-ssr>
      <!--- CAPTCHA -->
      <div
        v-if="
          (data.themeType == 'Classic' ||
            (data.themeType != 'Classic' &&
              data.templateType != 'RightSidebar') ||
            (data.themeType != 'Classic' &&
              data.templateType == 'RightSidebar' &&
              !isSizeWindow)) &&
          isCaptchaVisible
        "
        class="checkout-content--right__feature embed-checkout-right-button embed-buyButton flex align-items-center grid-gap15px mb-2 justify-center"
      >
        <vue-hcaptcha
          :sitekey="googleCaptchaKey"
          @verify="verifyCaptcha"
          @expired="expiredMethod"
          @challenge-expired="expiredMethod"
        ></vue-hcaptcha>
      </div>

      <!--Create Order-->
      <div class="theme--tuktuk__navigation-bottom theme--tuktuk__checkout__navigation-bottom">
        <!-- TOTAL -->
        <div v-if="data.orderSummary && data.payload" class="theme--tuktuk__checkout__navigation-bottom__total">
          <div class="theme--tuktuk__checkout__navigation-bottom__total__content">
            <h2 class="theme--tuktuk__title">{{ $t("common.total") }}</h2>
            <p class="theme--tuktuk__title">
              <template v-if="data.multiplyVariations">
                <template v-if="this.data.payload.payment &&
      this.data.payload.payment != 'bankTransfer' &&
      this.data.payload.payment != 'COD'
      ">
                  Rp{{ data.totalPrice | g_number_format }}
                </template>
                <template v-else>
                  Rp{{
                    (data.cartSummary.length > 0 && cartTotalPrice
                      ? Math.round(cartTotalPrice + (data.VAT && data.VAT.isVAT ? (cartTotalPrice * data.VAT.VATpercentage)/100 : 0))
                      : data.totalPrice) | g_number_format
                  }}
                </template>
              </template>

              <template v-else>
                <template v-if="this.data.payload.payment &&
      this.data.payload.payment != 'bankTransfer' &&
      this.data.payload.payment != 'COD'
      ">
                  Rp{{ data.totalPrice | g_number_format }}
                </template>
                <template v-else>Rp{{ data.totalPrice | g_number_format }}</template>
              </template>
            </p>
          </div>
          <!-- <p class="theme--tuktuk__checkout__navigation-bottom__total__info">Anda menghemat Rp122.000</p> -->
        </div>
        <button class="theme--tuktuk__button-pink--fill" :style="(data.isBuyButtonLoading | data.loadingPrice
      ? '; opacity: 0.5; pointer-event: none; cursor: default;'
      : '')
      " :disabled="data.isBuyButtonLoading || data.loadingPrice || (isCaptchaVisible && !verifiedCaptcha)" @click="() => !data.loadingPrice && onSubmitted()">
      {{ this.data.tuktukThemeSetting.secondStepButtonText || $t("tuktukTheme.createOrder") }}</button>
      </div>
   </no-ssr>


  </div>
</template>
<script>
import BumpOrder from "./BumpOrder.vue";
import OrderSummery from "./OrderSummery.vue";
import PaymentMethod from "./PaymentMethod.vue";
import RequestedFields from "./RequestedFields.vue";
import Shipping from "./Shipping.vue";
// import ShopDiscount from "./ShopDiscount.vue";
import ViewOrderSummery from "./ViewOrderSummery.vue";
import Coupon from "../ProductDetails/Coupon.vue";
import config from "./../../../../config.js";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import axios from 'axios';
import { AUTOFILL_SOURCE, saveAutofillSource, toggleSaveDataChecked } from "@/helpers/checkoutAutofillHelper";

export default {
  props: ["data", "submited", "shippingCourierItems", "user", "isMobile", "showCaptcha", "isInvalidCustomerPhone"],
  data() {
    return {
      showOrderSummery: false,
      navigationHeight: 110,
      googleCaptchaKey: config.googleCaptchaKey,
      verifiedCaptcha: false,
    };
  },
  components: {
    BumpOrder,
    OrderSummery,
    PaymentMethod,
    RequestedFields,
    Shipping,
    ViewOrderSummery,
    // ShopDiscount,
    Coupon,
    VueHcaptcha,
  },
  computed: {
    cartTotalPrice: {
      get() {
        return this.data.cartTotal;
      },
      set(val) {
        this.$emit("updateCartTotal", val);
      },
    },
    isCaptchaVisible() {
      // hide captcha on abandoned checkout
      if ('checkout_id' in this.$route.query && !!this.data.checkout_data.form_id) return false

      return this.showCaptcha
    },
    isAddressUnsupported() {
      if (!this.data.isShippingCoverageCheckEnabled) return ({
        unsupported: false,
        unsupported_cod: false
      });

      const selectedCourier =
        [...this.data.courierOptionDataFinal, ...this.data.courierOptionDataCargo || []].find(courier => courier.key === this.data.payload.deliveryCourier)
                
      return ({
        unsupported: selectedCourier ? selectedCourier.unsupported : false,
        unsupported_cod: selectedCourier && selectedCourier ? selectedCourier.unsupported_cod : false
      });
    }
  },
  methods: {
    setSelectedAddresses(addresses) {
      this.$emit('setSelectedAddresses', addresses)
    },
    applyDiscount(val) {
        this.$emit("applyDiscount", val);
    },
    clearDiscount(code) {
        this.$emit("clearDiscount", code);
    },
    updateDiscountLists(discounts,replace){
      this.$emit('updateDiscountLists',discounts,replace)
    },
    addToCart() {
      this.$emit("addToCart");
    },
    addCartItem() {
        this.$emit("addCartItem");
    },
    calcCart() {
      this.$emit("calcCart");
    },
    changeVariant(val) {
        this.$emit("changeVariant", val);
    },
    setStep(count) {
        const query = { ...this.$route.query, step: count };
        if (count === 1) {
          delete query.step;
        } else {
          query.step = count;
        }
        this.$emit("setStep", count);
        this.$router.push({ query });
    },
    updateCartQuantity(qty) {
      this.$emit("updateCartQuantity", qty);
    },
    updateCartSummary(index) {
      this.$emit("updateCartSummary", index);
    },
    updateCartTotal(total) {
      this.$emit("updateCartTotal", total);
    },
    onSubmitted() {
      const isUnsupported = this.isAddressUnsupported.unsupported || (this.isAddressUnsupported.unsupported_cod && this.data.payload.payment == 'COD')      
      if (isUnsupported && !this.data.isShippingCoverageCanOrder) {
        this.$vs.notification({
          icon: `<i class='icon-info'></i>`,
          color: "danger",
          position: "top-right",
          text: "Pengiriman yang kamu pilih belum support COD & Non COD",
          duration: 3000,
        });
        return;
      }
      this.$emit("onSubmitted");
    },
    // Only the "save" checkbox calls this.
    saveDataForNexttime() {
      toggleSaveDataChecked();
      let subdomain = window.location.hostname;
      let customerInfoArr = {};
      let customerAddrArr = {};
      if (this.data.requestedFields && subdomain) {
        customerInfoArr[subdomain] = this.data.requestedFields;
        localStorage.setItem(
          "CheckoutCustomerInfo",
          JSON.stringify(customerInfoArr)
        );
      }
      if (this.data.payload.address != null) {
        customerAddrArr[subdomain] = this.data.payload.address;
        localStorage.setItem(
          "CheckoutAddressInfo",
          JSON.stringify(customerAddrArr)
        );
      }
      saveAutofillSource(subdomain, AUTOFILL_SOURCE.SAVE_DATA);
    },
    getNavigationBottomHeight(initHeight = 110) {
      if (this.data.themeType=='TuktukStep1') {
        return 110
      }
      const elementNavigationBottom = document.querySelector(".theme--tuktuk__navigation-bottom")
      if (elementNavigationBottom) {
        return elementNavigationBottom.clientHeight;
      }
      return initHeight;
    },
    async verifyCaptcha(data) {
      let res = await axios.post(config.api + "auth/verifyGoogleCaptcha", {
        response: data,
      });
      if (res.data.data.success) {
        this.verifiedCaptcha = true;
      }
    },
    expiredMethod() {
      this.verifiedCaptcha = false;
    },
  },
  mounted() {
    if (this.data.type == "simple") {
      const index = this.data.requestedFields.findIndex(
        (x) => x.field == "quantity" && x.active
      );
      if (index > -1) {
        this.showOrderSummery = true;
      }
    } else if (
      this.data.type != "simple" &&
      this.data.multiplyVariations &&
      !this.data.cartOrder
    ) {
      this.showOrderSummery = true;
    } else if (
      this.data.type != "simple" &&
      !this.data.multiplyVariations &&
      this.data.addQuantity
    ) {

      this.showOrderSummery = true;
    } else if (
      this.data.type != "simple" &&
      this.data.multiplyVariations &&
      this.data.cartOrder &&
      this.data.addQuantity
    ) {

      this.showOrderSummery = true;
    }
    this.calcCart();
    this.getNavigationBottomHeight()
  }

};
</script>

<style scoped>
.theme--Tuktuk .theme--tuktuk__container {
  border: none;
}
</style>
